import { gql } from "apollo-boost"

export const getAll = gql`
  query getSubmissions(
    $state: State!,
    $status:[Status!],
    $region:[Region!],
    $skip: Float, 
    $first: Float,
    $search: String,
    $axis:String
  ) 
    {
    getSubmissionTotalCount (
    status:$status,
    search: $search,
    region:$region,
    axis:$axis )

    Submissions(
      state: $state,
      status: $status,
      skip: $skip, 
      first: $first,
      search: $search,
      region:$region,
      axis:$axis
    ) {
      id
      implementer {
        name
        commercialName
        account {
          displayName
          roles {
            role
          }
        }
      }
      rejectLog {
        id
        createdAt
        rejectedOnStatus
      }
      name
      type
      applyingCall
      township
      region
      strategicAxis
      status
      statusChangedAt
      startDate
      deadline
      modifiedAt
      endDate
      agreementNumber
      technicalOpinion
      createdAt
      budgeted
      approved
    }
    
    Implementer {
      rfc
      name
      email
      phone
      director
      legalRepresentative
    }
  }
`


export const getAllSubmissionTable = gql`
  query getSubmissions(
    $state: State!,
    $status:[Status!],
    $region:[Region!],
    $skip: Float, 
    $first: Float,
    $search: String,
    $axis:String
  ) 
    {
    getSubmissionTotalCount (
    status:$status,
    search: $search,
    region:$region,
    axis:$axis,
    state: $state, )

    NewSubmissionsDashboard(
      state: $state,
      status: $status,
      skip: $skip, 
      first: $first,
      search: $search,
      region:$region,
      axis:$axis
    ) {
      id
    implementer {
      name
      email
    }
    name
    type
    region
    strategicAxis
    status
    statusChangedAt
    endDate
    createdAt
    approved
    }
  }
`

/** consulta tabla proyectos */

export const getAllProyectsTable = gql`
  query getSubmissions(
    $state: State!,
    $status:[Status!],
    $region:[Region!],
    $skip: Float, 
    $first: Float,
    $search: String,
    $axis:String
  ) 
    {
    getSubmissionTotalCount (
    status:$status,
    search: $search,
    region:$region,
    axis:$axis,
    state: $state, )

    auditorYears
    NewProyectsTable(
      state: $state,
      status: $status,
      skip: $skip, 
      first: $first,
      search: $search,
      region:$region,
      axis:$axis
    ) {
      id
    implementer {
      name
    }
    name
    region
    strategicAxis
    status
    agreementNumber
    budgeted
    approved
    startDate
    endDate
    }
  }
`
